export default {
  state: {
    list: []
  },
  mutations: {
    // 添加一个缓存组件
    added: (state, keepAlive) => {
      let flag = true
      const arr = state.list

      arr.forEach(item => {
        if (item.path === keepAlive.path) {
          return (flag = false)
        }
      })

      if (flag) {
        state.list.push(keepAlive)
      }
    },
    // 关闭一个标签页
    removed: (state, keepAlive) => {
      const arr = state.list
      const len = arr.length

      for (let i = 0; i < len; i += 1) {
        if (arr[i].path === keepAlive.path) {
          state.list.splice(i, 1)
          return
        }
      }
    },
    // 关闭其他标签
    removeOther: (state, keepAlive) => {
      state.list = [keepAlive]
    },
    // 关闭全部
    removeAll: state => {
      state.list = []
    }
  }
}
